import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteRevenueCategory(): UseMutationResult<
  AxiosResponse<unknown>,
  AxiosError<ErrorMessage>,
  number | string
> {
  const queryClient = useQueryClient();

  const deleteRevenueCategory = useCallback(
    (categoryId: number | string): Promise<AxiosResponse<unknown>> => {
      return client.delete(`revenue-categories/${categoryId}/`);
    },
    [],
  );

  return useMutation(deleteRevenueCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries(['revenue-categories-autocomplete']);
      queryClient.removeQueries(['packageRevenueCategories']);
      queryClient.invalidateQueries(['revenueCategories']);
    },
  });
}
